import "./Services.module.css";
import Navigation from "@/reusable_sections/Header";
import Capabilities from "./sections/Capabilities";
import Methodology from "./sections/Methodology";
import Inquiry from "./sections/Inquiry";
import Footer from "@/reusable_sections/Footer";
export default function ServicesPage() {
  return <div>
      <Navigation />
      <Capabilities />
      <Methodology />
      <Inquiry />
      <Footer />
    </div>;
}